import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  model,
  OnInit,
  viewChild,
} from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';

@Component({
  selector: 'anbs-code-input',
  templateUrl: './code-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodeInputComponent implements FormValueControl<string>, OnInit {
  value = model('');
  touched = model(false);
  otpCode = viewChild<ElementRef>('otpCode');

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '').slice(0, 6);
    input.value = digits;
    this.value.set(digits);
  }

  ngOnInit() {
    this.otpCode().nativeElement.focus();
  }
}
